const host = 'https://tmsapi.ygalogisticspark.com/api/';
//const host = 'http://61.143.42.70:7010/cwgltest-api/';
//const host = 'http://127.0.0.1:8060/';
// const host = 'https://jyjyapi.ygalogisticspark.com/api2/zhfw/api/third';
const imageUrlYL = 'http://localhost:8080';
const aliOssUrl = 'https://huichang-tms.oss-cn-hongkong.aliyuncs.com';
const config = {
    host,imageUrlYL,aliOssUrl,
    title: '交控集团智慧物流调度平台'
}

export default config;
